const PASS_RUSH_PLAYS = ['PASS', 'RUSH'];

export const forPassRushPlays = ({ node: { type } }) =>
  PASS_RUSH_PLAYS.includes(type);

export const byGameIndex = (a, b) =>
  a.node.gameIndex > b.node.gameIndex ? 1 : 0;
